module.exports = __webpack_public_path__ + "assets/img/2021-midAutumn-2.1ce78e98.png";